import React from 'react';
import { Box, Typography } from '@mui/material';

const BingoCard = ({ card, onMark }) => {
  const columnHeaders = ['C', 'R', 'O', 'W', 'N'];

  return (
    <Box
      sx={{
        maxWidth: 600,
        width: '100%',
        mx: 'auto',
        p: { xs: 1, sm: 2 },
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(5, 1fr)',
          gridTemplateRows: 'auto repeat(5, 1fr)',
          gap: { xs: 0.5, sm: 1 },
          bgcolor: 'grey.100',
          border: 2,
          borderColor: 'grey.800',
          borderRadius: 2,
          p: { xs: 0.5, sm: 1 },
          aspectRatio: '1 / 1',
        }}
      >
        {/* Header Row */}
        {columnHeaders.map((letter, idx) => (
          <Box
            key={idx}
            sx={{
              bgcolor: '#B43361',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 1,
              border: 1,
              borderColor: 'grey.300',
              fontWeight: 'bold',
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
              height: 80,
            }}
          >
            <Typography color='white' variant="h4" fontWeight="bold">
              {letter}
            </Typography>
          </Box>
        ))}

        {/* Number Cells */}
        {card.flatMap((row, rowIdx) =>
          row.map((cell, colIdx) => (
            <Box
              key={`${rowIdx}-${colIdx}`}
              onClick={() => onMark(rowIdx, colIdx)}
              sx={{
                bgcolor: cell.marked ? 'success.main' : 'background.paper',
                color: cell.marked ? 'success.contrastText' : 'text.primary',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: 1,
                borderColor: 'grey.300',
                borderRadius: 1,
                aspectRatio: '1 / 1',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                '&:hover': {
                  bgcolor: cell.marked ? 'success.main' : 'grey.200',
                },
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' },
              }}
            >
              <Typography variant="body1" fontSize={20} fontWeight="bold">
                {cell.number || 'FREE'}
              </Typography>
            </Box>
          ))
        )}
      </Box>
    </Box>
  );
};

export default BingoCard;